import './styles.css';
import KickstarterLogo from '../../assets/KickstarterLogo.png';

export function KickstarterButton({ className = '', href, ...rest }) {
  const handleClick = (e) => {
    e.preventDefault();
    window.open(href, '_blank');
  };

  return (
    <a className={className} href={href} onClick={handleClick} {...rest}>
      <img src={KickstarterLogo} alt="Kickstarter Logo" className="KickstarterImg" />
    </a>
  );
}

